import { NgModule } from '@angular/core';
import { IncidentService } from '../incident/services/incident.service';
import { ProhibitionAAMVAService } from '../prohibition/services/prohibition-aamva.service';
import { ProhibitionService } from '../prohibition/services/prohibition.service';

@NgModule({
    providers: [
        IncidentService,
        ProhibitionService,
        ProhibitionAAMVAService
    ]
})
export class DriverRecordCoreModule { }
